const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  APP_NAME: process.env.REACT_APP_APP_NAME,
  GITHUB_OAUTH_CLIENT_ID: process.env.REACT_APP_GITHUB_OAUTH_CLIENT_ID,
};

export const constants = {
  appLogo: "/logo.png",
  themeColor: "#18e9b4",
};

export default config;
